export default __webpack_public_path__ + "static/media/Picture1.93821c58.JPG";